import { defineComponent as _defineComponent } from 'vue'
import { XCircleIcon } from '@heroicons/vue/solid';

interface Meta {
  valid: boolean;
  touched: boolean;
}

interface Props {
  label?: string;
  name: string;
  errorMessage: string;
  meta: Meta;
  labelPosition?: 'top' | 'left';
}


export default /*#__PURE__*/_defineComponent({
  __name: 'base',
  props: {
    label: { type: String, required: false, default: '' },
    name: { type: String, required: true, default: '' },
    errorMessage: { type: String, required: true, default: '' },
    meta: { type: Object, required: true },
    labelPosition: { type: String, required: false, default: 'top' }
  },
  setup(__props: any, { expose }) {
  expose();

const props = __props as { label: string, name: string, errorMessage: string, meta: Meta, labelPosition: 'top' | 'left' }



const __returned__ = { props, XCircleIcon }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})